// extracted by mini-css-extract-plugin
export default {"wrapper":"FadeIn_wrapper__UGpcY","fadeIn":"FadeIn_fadeIn__ThRu4"};